import { fmtCurrency } from '../../lib/format.js';

// Differenz-/Ersparnis-Banner unter dem Betrag im Verkaufs-NumPad.
// kind="wish":   Abweichung vom Wunschpreis (Einzelverkauf)
// kind="bundle": Ersparnis des Kunden gegenüber der Einzelsumme
// Feste Höhe (Slot im NumPad) → kein Layout-Sprung beim Tippen.
export function PriceDeltaNote({ value, reference, kind = 'wish' }) {
  if (reference == null || !(reference > 0)) return null;
  const diff = Math.round((value - reference) * 100) / 100;
  if (diff === 0) {
    return (
      <span data-testid="price-delta" data-state="equal" className="text-[15px] text-[var(--label-secondary)]">
        {kind === 'bundle' ? 'Summe der Einzelpreise' : 'Entspricht dem Wunschpreis'}
      </span>
    );
  }
  const below = diff < 0;
  const text = kind === 'bundle'
    ? (below ? `Kunde spart ${fmtCurrency(-diff)}` : `${fmtCurrency(diff)} über Einzelsumme`)
    : (below ? `${fmtCurrency(-diff)} unter Wunschpreis` : `${fmtCurrency(diff)} über Wunschpreis`);
  // Unter Wunschpreis = Zugeständnis (gelb); Bundle-Ersparnis = gutes Argument (grün); darüber = grün
  const tone = kind === 'bundle' || !below
    ? 'bg-[var(--tint-stand)]'
    : 'bg-[var(--tint-yellow)]';
  return (
    <span
      data-testid="price-delta"
      data-state={below ? 'below' : 'above'}
      className={`num rounded-full px-3 py-1 text-[15px] font-semibold text-[var(--label-primary)] ${tone}`}
    >
      {text}
    </span>
  );
}
